import { useState, useEffect } from 'react';

import { CONVERSION_MODE } from '@/constants';

import usePriorConversions from './usePriorConversions';

const { skip, default: defaultMode } = CONVERSION_MODE;

const useConversionMode = ({
  source,
  target,
  sourceId,
  isSelection,
  sourceIds = [],
  withSourceAccount,
}) => {
  const [mode, setMode] = useState(defaultMode);

  const {
    error,
    isLoading,
    conversions: priorConversions,
  } = usePriorConversions({
    source,
    target,
    enabled: true,
    withSourceAccount,
  });

  let hasPriorConversions = false;
  let allHavePriors = false;

  if (priorConversions) {
    if (sourceId !== undefined) {
      hasPriorConversions = !!priorConversions[sourceId];
      allHavePriors = hasPriorConversions;
    } else if (isSelection) {
      hasPriorConversions = sourceIds.some((id) => priorConversions[id]);
      allHavePriors =
        sourceIds.length > 0 && sourceIds.every((id) => priorConversions[id]);
    } else if (isSelection === false) {
      // all-mode: source playlist count is unknown until convert time, so
      // "all converted" is undetectable here — allHavePriors stays false.
      hasPriorConversions = Object.keys(priorConversions).length > 0;
    }
  }

  const wouldSkipAll = mode === skip && allHavePriors;

  useEffect(() => {
    if (hasPriorConversions) {
      setMode((prev) => (prev === defaultMode ? skip : prev));
    } else {
      setMode(defaultMode);
    }
  }, [hasPriorConversions]);

  return {
    mode,
    error,
    setMode,
    isLoading,
    wouldSkipAll,
    priorConversions,
    hasPriorConversions,
  };
};

export default useConversionMode;
